// @flow
import { login, logout, signup, forgotPassword, forgotPasswordConfirm } from './auth';
import {
    ApiGetAllKategoriRoom,
    ApiGetAllRoom,
    ApiPostCategoryRoom,
    ApiPostRoom,
    ApiEditKategoriRoom,
    // ApiDeleteKategoriRoom,
    ApiEditRoom,
} from './room';
import {
    ApiGetAllMenu,
    ApiGetAllKategoriMenu,
    ApiEditKategoriMenu,
    ApiPostCategoryMenu,
    ApiPostMenu,
    ApiEditMenu,
} from './menu';
import {
    ApiGetAllFasilitas,
    ApiEditFasilitas,
    ApiPostFasilitas,
    ApiGetReportFasilitas,
    ApiGetReportTerapisFasilitas,
    ApiPrintFasilitas,
    ApiPrintExcelFasilitas,
} from './fasilitas';
import { ApiGetAllBisnis, ApiPostBisnis, ApiEditBisnis } from './bisnis';
import { ApiGetAllHarga, ApiPostHarga, ApiEditHarga } from './harga';
import { ApiGetAllGelang, ApiPostGelang, ApiEditGelang } from './gelang';
import {
    ApiGetAllThreatment,
    ApiPostThreatment,
    ApiEditThreatment,
    ApiGetReportThreatment,
    ApiGetReportTerapisThreatment,
    ApiPrintPdfThreatment,
    ApiPrintExcelThreatment,
    ApiGetReportTglThreatment,
} from './threatment';
import { ApiGetAllTerapis, ApiPostTerapis, ApiEditTerapis, ApiGetReportTerapis } from './terapis';
import {
    ApiGetAllKategoriBarang,
    ApiGetAllBarang,
    ApiPostCategoryBarang,
    ApiPostBarang,
    ApiEditKategoriBarang,
    ApiEditBarang,
} from './barang';
import { ApiGetAllMenupaket, ApiPostMenupaket, ApiEditMenupaket } from './menupaket';
import { ApiGetAllSatuan, ApiPostSatuan, ApiEditSatuan } from './satuan';
import { ApiGetAllKomposisi, ApiPostKomposisi, ApiEditKomposisi } from './komposisi';
import {
    ApiGetAllSearch,
    ApiOrderFasilitas,
    ApiOrderMenu,
    ApiOrderRoom,
    ApiOrderTerapis,
    ApiOrderThreatment,
    ApiEditStatus,
} from './search';
import {
    ApiGetAllPayment,
    ApiGetAllBank,
    ApiPostPayment,
    ApiPutPayment,
    ApiGetPaymentCompany,
    ApiPostPaymentCompany,
    ApiGetCompany,
    ApiPostTagihanCompany,
    ApiPutCompany,
    ApiGetAllReportPayment,
    ApiGetAllReportTransaksi,
    ApiPrintTransaksi,
    ApiPrintExcelTransaksi,
    ApiPrintPayment,
    ApiPrintExcelPayment,
} from './payment';
import { ApiGetAllUsers, ApiPostUser, ApiEditEmail, ApiCreateOTP, ApiAktivasi } from './user';
import { ApiGetAllTax, ApiPostTax, ApiEditTax } from './tax';
import { ApiGetAllPromo, ApiPostPromo, ApiEditPromo } from './promo';
import { ApiGetAllDepartment, ApiPostDepartment, ApiEditDepartment } from './department';
import { ApiGetAllPegawai, ApiPostPegawai, ApiEditPasswordPegawai } from './pegawai';
import { ApiGetAllCompany, ApiPostCompany } from './company';
import { ApiGetAllRekap } from './rekap';
export {
    login,
    logout,
    signup,
    forgotPassword,
    forgotPasswordConfirm,
    ApiGetAllKategoriRoom,
    ApiGetAllRoom,
    ApiPostCategoryRoom,
    ApiPostRoom,
    ApiEditKategoriRoom,
    ApiEditRoom,
    ApiGetAllMenu,
    ApiGetAllKategoriMenu,
    ApiGetAllFasilitas,
    ApiPostFasilitas,
    ApiEditFasilitas,
    ApiEditKategoriMenu,
    ApiPostCategoryMenu,
    ApiPostMenu,
    ApiEditMenu,
    ApiGetAllBisnis,
    ApiPostBisnis,
    ApiEditBisnis,
    ApiGetAllHarga,
    ApiEditHarga,
    ApiPostHarga,
    ApiGetAllGelang,
    ApiPostGelang,
    ApiEditGelang,
    ApiGetAllThreatment,
    ApiPostThreatment,
    ApiEditThreatment,
    ApiGetAllTerapis,
    ApiPostTerapis,
    ApiEditTerapis,
    ApiGetAllBarang,
    ApiGetAllKategoriBarang,
    ApiEditKategoriBarang,
    ApiPostCategoryBarang,
    ApiPostBarang,
    ApiEditBarang,
    ApiGetAllMenupaket,
    ApiPostMenupaket,
    ApiEditMenupaket,
    ApiGetAllSatuan,
    ApiPostSatuan,
    ApiEditSatuan,
    ApiGetAllKomposisi,
    ApiPostKomposisi,
    ApiEditKomposisi,
    ApiGetAllSearch,
    ApiGetAllPayment,
    ApiGetAllBank,
    ApiPostPayment,
    ApiPutPayment,
    ApiOrderFasilitas,
    ApiOrderMenu,
    ApiOrderRoom,
    ApiOrderTerapis,
    ApiOrderThreatment,
    ApiEditStatus,
    ApiGetAllUsers,
    ApiPostUser,
    ApiGetAllTax,
    ApiPostTax,
    ApiEditTax,
    ApiGetReportTerapis,
    ApiGetReportThreatment,
    ApiGetReportFasilitas,
    ApiGetAllPromo,
    ApiPostPromo,
    ApiEditPromo,
    ApiGetAllReportPayment,
    ApiGetAllReportTransaksi,
    ApiGetPaymentCompany,
    ApiPostPaymentCompany,
    ApiGetCompany,
    ApiPostTagihanCompany,
    ApiPutCompany,
    ApiEditEmail,
    ApiGetReportTerapisThreatment,
    ApiGetReportTerapisFasilitas,
    ApiGetAllDepartment,
    ApiPostDepartment,
    ApiEditDepartment,
    ApiGetAllPegawai,
    ApiPostPegawai,
    ApiEditPasswordPegawai,
    ApiCreateOTP,
    ApiAktivasi,
    ApiGetAllCompany,
    ApiPostCompany,
    ApiGetAllRekap,
    ApiPrintTransaksi,
    ApiPrintPayment,
    ApiPrintFasilitas,
    ApiPrintPdfThreatment,
    ApiPrintExcelThreatment,
    ApiGetReportTglThreatment,
    ApiPrintExcelFasilitas,
    ApiPrintExcelPayment,
    ApiPrintExcelTransaksi,
};
